import React, { useState, useEffect } from 'react';
import { Button } from './Button';

export const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('zackig-cookie-consent');
    if (!consent) {
      // Small delay to not overwhelm the user immediately on load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('zackig-cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('zackig-cookie-consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 p-4 md:p-6 animate-fade-in-up">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8">
        <div className="text-sm text-gray-600 leading-relaxed text-center md:text-left">
          <p>
            <span className="font-bold text-brand-dark">Wir nutzen Cookies.</span> 🍪 
            Um unsere Webseite für dich optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. 
            Durch die weitere Nutzung der Webseite stimmst du der Verwendung von Cookies zu.
          </p>
        </div>
        <div className="flex flex-row gap-3 w-full md:w-auto justify-center">
          <Button 
            variant="outline" 
            onClick={handleDecline}
            className="!py-2 !px-4 !text-xs md:!text-sm whitespace-nowrap"
          >
            Ablehnen
          </Button>
          <Button 
            variant="primary" 
            onClick={handleAccept}
            className="!py-2 !px-4 !text-xs md:!text-sm whitespace-nowrap shadow-none"
          >
            Alles akzeptieren
          </Button>
        </div>
      </div>
    </div>
  );
};